import { useDispatch } from 'react-redux';
import { useCallback, useState } from 'react';
import { EditPC } from '../../../../../../dialogs/edit/edit.pc';
import { Input } from '../../../../../../ui/input/input';
import { Required } from '../../../../../../ui/required/required';
import { ValidationLengthUnder10, ValidationLengthUnder255 } from '../../../../../../../model/validation';
import { RightLabelCheckbox } from '../../../../../../ui/checkbox/right-label-checkbox/right-label-checkbox';
import { ColorPicker } from '../../../../../../ui/color-picker/color-picker';
import { MasterEditDialogProps } from '../../../master.type';
import { useAppSelector } from '../../../../../../../hooks/use-redux';
import { useDidMount } from '../../../../../../../hooks/life-cycle';
import { ValidationMax10Billion } from '../../../../../../../model/validation/validation-max-10-billion';
import { InputNum } from '../../../../../../ui/input/input-num';
import { MasterCustomerRankValidation } from '../../../../../../../model/validation/master/master-customer-rank.validation';
import { DialogActions } from '../../../../../../../redux/dialog/dialog.action';
import { Message } from '../../../../../../../collection/message.collection';
import { MasterActions } from '../../../../../../../redux/master/master.action';
import { ValidationLengthUnder1 } from '../../../../../../../model/validation/_validation-length-under-1';
import { MathHelper } from '../../../../../../../utilities/math-helper';
import { ValidationEisuzi } from '../../../../../../../model/validation/validation-eisuzi';

export const CustomerRankMasterEditDialog = (props: MasterEditDialogProps) => {
  const { id, callback } = props;
  const dispatch = useDispatch();
  const list = useAppSelector((state) => state.master.customerKojiRankList);

  /* State */
  const [name, setName] = useState('');
  const [abbreviation, setAbbreviation] = useState('');
  const [backGround, setBackGround] = useState('');
  const [textColor, setTextColor] = useState('');
  const [validFlag, setValidFlag] = useState(true);
  const [amount, setAmount] = useState('');

  const [touch, setTouch] = useState(false);

  const handleClickPost = useCallback(() => {
    if (MasterCustomerRankValidation(
      name,
      abbreviation,
      backGround,
      textColor,
      amount,
    )) {
      dispatch(DialogActions.pushMessage({
        title: '顧客ランク（工事金額） 編集／追加',
        message: Message.postError,
        callback: () => setTouch(true),
      }));
      return;
    }

    dispatch(MasterActions.api.customerKojiRank.post({
      param: {
        data: {
          name,
          abbreviation,
          background_color: backGround,
          text_color: textColor,
          amount: MathHelper.localStrToNum(amount),
          is_valid: validFlag ? 1 : 0,
        },
        id,
      },
      onSuccess: () => callback(),
      onError: () => setTouch(true),
    }));
  }, [
    name,
    abbreviation,
    backGround,
    textColor,
    validFlag,
    amount,
  ]);

  useDidMount(() => {
    if (id) {
      const data = list.find((f) => Number(f.id) === id);
      if (!data) return;
      setName(data.name);
      setAbbreviation(data.abbreviation);
      setValidFlag(data.valid_flag);
      setTextColor(data.text_color);
      setBackGround(data.background_color);
      setAmount(String(data.amount));
    }
  });

  return (
    <EditPC mode="dialog" callback={handleClickPost} label={id ? '更新' : '登録'}>
      <div className="edit_pc_body_inner edit_master cusomer_rank_master">
        <div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">顧客ランク（工事金額）<Required /></div>
              <Input
                require
                className=""
                value={name}
                onChange={(e) => setName(e.target.value)}
                touch={touch}
                errorPosBottom
                maxLength={10}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">略式表示<Required /></div>
              <Input
                className=""
                value={abbreviation}
                onChange={(e) => setAbbreviation(e.target.value)}
                require
                validationList={ValidationEisuzi}
                maxLength={1}
                touch={touch}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">工事金額<Required /></div>
              <InputNum
                require
                value={!amount ? '' : MathHelper.localStr(amount)}
                onChange={setAmount}
                touch={touch}
                intLen={10}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">背景色<Required /></div>
              <ColorPicker
                title="カラーピッカー"
                fontAwesomeClass="fas fa-eye-dropper"
                className="secondary"
                color={backGround}
                callbackColor={setBackGround}
                require
                touch={touch}
              />
              {/* datepickerと同じようにinput内にアイコンの形にする  */}
              {/*
              <IconButton
                title="カラーピッカー"
                fontAwesomeClass="fas fa-eye-dropper"
                className="secondary"
                disabled
                onClick={() => {}}
              />
              */}
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">文字色<Required /></div>
              <ColorPicker
                title="カラーピッカー"
                fontAwesomeClass="fas fa-eye-dropper"
                className="secondary"
                callbackColor={setTextColor}
                color={textColor}
                require
                touch={touch}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">有効フラグ</div>
              <RightLabelCheckbox
                label=""
                className="is_valid"
                checked={validFlag}
                onChange={() => setValidFlag(!validFlag)}
              />
            </div>
          </div>
        </div>
      </div>
    </EditPC>
  );
};
